import {
  Button,
  Center,
  FormControl,
  Heading,
  Input,
  Text,
} from '@chakra-ui/react';
import { AiOutlineSend } from 'react-icons/ai';

const Newsletter = () => {
  return (
    <Center flexDir={'column'} bg="#f5fafd" h="60vh">
      <Heading color="teal" as="h2" fontSize={['34px', '50px', '70px']}>
        Newsletter
      </Heading>
      <Text fontSize={'24px'} fontWeight="300" textAlign={'center'} py="5px">
        Subscribe to Get updates on latest products
      </Text>
      <FormControl
        w={['80%', '80%', '50%']}
        display="flex"
        py="5"
        mx="auto"
        justifyContent="space-between"
      >
        <Input
          bg="white"
          size="x;l"
          borderColor="teal"
          pl="20px"
          placeholder="Email Here"
        />
        <Button colorScheme="teal" roundedStart="0" fontSize="30px">
          {/* <AiOutlineSend /> */}
        </Button>
      </FormControl>
    </Center>
  );
};

export default Newsletter;
